export * from './Segment';
export { default } from './Segment';
//# sourceMappingURL=index.js.map